/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { getFieldZoneLayout } from "cms/fields/field-utils";
import { PhoneNumberFieldDisplay } from "./display";
import { PhoneNumberFieldEdit } from "./edit";

const PhoneNumberField = (props) => {

    const zoneProps = {
        ...props,
        displayComponent: <PhoneNumberFieldDisplay />,
        editComponent: <PhoneNumberFieldEdit />,
    };
    return getFieldZoneLayout(zoneProps);
};
PhoneNumberField.displayName = "PhoneNumberField";
export { PhoneNumberField };
